import script from "./PendencyService.vue?vue&type=script&setup=true&lang=js"
export * from "./PendencyService.vue?vue&type=script&setup=true&lang=js"

import "./PendencyService.vue?vue&type=style&index=0&id=1dfbb6e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dfbb6e4"]])

export default __exports__